
export default {
    queueClinicList(model) {
        return window.restApi.get('v2/queue/list', {params: model});
    },
    queuePCRList(model) {
        return window.restApi.get('v2/queue/list', {params: model});
    },
    specimenList(model) {
        return window.restApi.get('v2/queue/specimen/list', {params: model});
    },
    getDetail(id) {
        return window.restApi.get('v2/visit/get/' + id);
    },
    getDetailV2(id) {
        return window.restApi.get('v2/visit/get/table/' + id);
    },
    getDetailQueue(id) {
        return window.restApi.get('v2/queue/get/' + id);
    },
    getVerify(id) {
        return window.restApi.get('v2/visit/get/verify/' + id);
    },
    getVerifyV2(id) {
        return window.restApi.get('v2/visit/get/verify/v2/' + id);
    },
    getVerifyFinal(id) {
        return window.restApi.get('v2/visit/get/verifyfinal/' + id);
    },
    getVerifyFinal2(id) {
        return window.restApi.get('v2/visit/get/verifyfinal/v2/' + id);
    },
    toWorklist(model, config) {
        return window.restApi.post('v2/queue/toworklist/', model, config);
    },
    specimenAccept(model, config) {
        return window.restApi.post('v2/queue/specimen/accept', model, config);
    },
    specimenReject(model, config) {
        return window.restApi.post('v2/queue/specimen/reject', model, config);
    },
    listWorklistClinic(model) {
        return window.restApi.get('v2/visit/list', {params: model});
    },
    listWorklistPCR(model) {
        return window.restApi.get('v2/visit/list', {params: model});
    },
    start(model, config) {
        return window.restApi.post('v2/visit/start', model, config);
    },
    entry(model, config) {
        return window.restApi.post('v2/visit/entry', model, config);
    },
    verify(model, config) {
        return window.restApi.post('v2/visit/verify', model, config);
    },
    verifyFinal(model, config) {
        return window.restApi.post('v2/visit/verifyfinal', model, config);
    },
    validEdit(model, config) {
        return window.restApi.post('v2/visit/postfinal', model, config);
    },
    listVisitInstrument(id) {
        return window.restApi.get('v2/visit/instrument/get/' + id);
    },
    getVisitProduct(id) {
        return window.restApi.get('v2/visit/product/get/' + id);
    },
    addProduct(model, config) {
        return window.restApi.post('v2/visit/product/add', model, config);
    },
    addTest(model, config) {
        return window.restApi.post('v2/visit/addtest', model, config);
    },
    removeTest(model, config) {
        return window.restApi.post('v2/visit/removetest', model, config);
    },
    cancelTest(model, config) {
        return window.restApi.post('v2/visit/canceltest', model, config);
    },
    barcode(model, config) {
        return window.restApi.post('v2/visit/barcode', model, config);
    },    
}
